import { render } from "./Test.vue?vue&type=template&id=6723a0f2"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
script.render = render

export default script